import React from 'react';

import IconType from '../../../types/Icon';

const PlusIcon: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path d="M11 3V11H3V13H11V21H13V13H21V11H13V3H11Z" fill={color} />
		</svg>
	);
};

export default PlusIcon;
